export default __webpack_public_path__ + "static/media/hand.6ae680a2.gif";